import { render, staticRenderFns } from "./FoodPackageRules.vue?vue&type=template&id=7acf9407&scoped=true"
import script from "./FoodPackageRules.vue?vue&type=script&lang=js"
export * from "./FoodPackageRules.vue?vue&type=script&lang=js"
import style0 from "./FoodPackageRules.vue?vue&type=style&index=0&id=7acf9407&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acf9407",
  null
  
)

export default component.exports